import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { serverError } from "../../redux/actions/userActions";
import Navbar from "../../components/navbar/navbar";
import Authentication from "../../components/authentication/authenticatedComponent";
import ElectiveCard from "../../components/ElectiveCard";
import Loader from "react-loader-spinner";
import "../enrollment/electiveCard.css";
import {
    api_get_enrollment_data,
    api_submit_enrollment,
} from "../../api/api";
import Modal from "../../components/common/modal";
import ValidationMessage from "../../components/common/validation-message";

const PracticeDurationCard = ({ value, onClick, isSelected, width }) => {
    const [hovered, setHovered] = React.useState(false);

    const cardClass = [
        "elective-card",
        "card",
        "shadow",
        "mb-2",
        isSelected && "selected",
        hovered && "hovered",
    ]
        .filter(Boolean)
        .join(" ");

    return (
        <div
            className={cardClass}
            style={{
                cursor: "pointer",
                textAlign: "center",
                width: typeof width === "number" ? `${width}%` : width,
            }}
            onClick={onClick}
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
        >
            <div className="elective-card-content">
                <span className="elective-card-title">{value}</span>
            </div>
        </div>
    );
};

class Enrollment extends Component {
    state = {
        electives: [],
        selectedElectives: [],
        hoveredElective: null,
        hasSubmitted: false,
        loading: true,
        submitting: false,
        error: null,
        isRegistrationOpen: true,
        isEligible: true,
        message: "",
        eligibilityMessage: "",
        validationError: "",
        showConfirmationModal: false,
        selectedSubject: null,
        selectedDuration: null,
    };

    componentDidMount() {
        this.fetchEnrollmentData();
    }

    fetchEnrollmentData = () => {
        api_get_enrollment_data(
            this.props.access_token,
            (response) => {
                if (response && typeof response === "object" && response.electives) {
                    const electives = response.electives || [];
                    const preselected = response.currentElectiveName
                        ? electives.find(
                              (e) =>
                                  e.name === response.currentElectiveName ||
                                  e.id === response.currentElectiveName
                          )
                        : null;

                    const selectedKey = preselected
                        ? preselected.id ?? preselected.name
                        : null;

                    this.setState({
                        electives,
                        selectedElectives: selectedKey ? [selectedKey] : [],
                        selectedSubject: preselected || null,
                        hasSubmitted: false,
                        isRegistrationOpen: response.isRegistrationOpen,
                        isEligible: response.isEligible,
                        message: response.message || "",
                        eligibilityMessage: response.eligibilityMessage || "",
                        loading: false,
                    });
                } else {
                    this.setState({
                        loading: false,
                        error: "Failed to parse enrollment data.",
                    });
                }
            },
            (error) => {
                this.setState({ loading: false, error });
                this.props.serverError(error);
            }
        );
    };

    handleSelect = (key) => {
        const selectedSubject = this.state.electives.find(
            (subject) => subject.id === key || subject.name === key
        );

        this.setState((prevState) => ({
            selectedElectives: prevState.selectedElectives.includes(key) ? [] : [key],
            selectedSubject: prevState.selectedElectives.includes(key) ? null : selectedSubject,
            selectedDuration: null,
            validationError: "", 
        }));
    };

    handleMouseEnter = (key) => {
        this.setState({ hoveredElective: key });
    };

    handleMouseLeave = () => {
        this.setState({ hoveredElective: null });
    };

    handleSelectDuration = (value) => {
        this.setState({ selectedDuration: value, validationError: "" });
    };

    handleSubmit = () => {
        const { selectedElectives, electives, selectedDuration } = this.state;
        let validationError = "";

        if (selectedElectives.length === 0) {
            validationError = "Please select your focus to submit.";
        } else {
            const [selectedKey] = selectedElectives;
            const selectedSubject = electives.find(
                (subject) => subject.id === selectedKey || subject.name === selectedKey
            );

            if (selectedSubject?.is_practice_only === "1" && !selectedDuration) {
                validationError = `Please choose a weekly appointment tier (1, 2, or 3) for ${selectedSubject.name}.`;
            }
        }

        if (validationError) {
            this.setState({ validationError });
            return;
        }

        const [selectedKey] = selectedElectives;
        const selectedSubject = electives.find(
            (subject) => subject.id === selectedKey || subject.name === selectedKey
        );
        this.setState({ selectedSubject, showConfirmationModal: true, validationError: "" });
    };

    confirmEnrollment = () => {
        const { selectedSubject, selectedDuration } = this.state;

        const payload = {
            elective_id: selectedSubject?.id,
            ...(selectedSubject?.is_practice_only === "1" && {
                practice_tier: selectedDuration,
            }),
        };

        this.setState({ submitting: true, error: null, showConfirmationModal: false });
        console.log("Submitting enrollment with payload:", payload);
        api_submit_enrollment(
            this.props.access_token,
            payload,
            (response) => {
                if (response.success) {
                    this.setState({
                        hasSubmitted: true,
                        submitting: false,
                        message: response.message || "Enrollment successful!",
                    });
                } else {
                    this.setState({
                        submitting: false,
                        error: response.message || "Submission failed.",
                    });
                }
            },
            (error) => {
                this.setState({ submitting: false, error });
                this.props.serverError(error);
            }
        );
    };

    render() {
        const {
            loading,
            error,
            electives,
            selectedElectives,
            hoveredElective,
            hasSubmitted,
            submitting,
            isRegistrationOpen,
            isEligible,
            message,
            eligibilityMessage,
            validationError,
            showConfirmationModal,
            selectedSubject,
            selectedDuration,
        } = this.state;

        if (loading) {
            return (
                <>
                    <Authentication />
                    <Navbar />
                    <div className="text-center">
                        <Loader type="Puff" color="#BB23F9" height={100} width={100} />
                    </div>
                </>
            );
        }


        let messageToShow = null;
        if (!isRegistrationOpen) messageToShow = message || "Registration is currently closed.";
        else if (!isEligible) messageToShow = eligibilityMessage || "You are not eligible to enroll.";
        else if (eligibilityMessage) messageToShow = eligibilityMessage;
        else if (hasSubmitted && message) messageToShow = message;

        return (
            <>
                <Authentication />
                <Navbar />
                <div className="container mt-5">
                    {messageToShow ? (
                        <h3 className="row mb-3 elective-card-title justify-content-center"
                            role="alert"
                            style={{ backgroundColor: 'transparent', border: 'none', fontSize: "1.6rem" }}
                        >
                            {messageToShow}
                        </h3>
                    ) : (
                        <>
                            <h3 className="row mb-3 elective-card-title justify-content-center"
                                style={{ fontSize: "1.6rem" }}>
                                Choose Your Focus for the Upcoming Semester
                            </h3>
                            <div className="row justify-content-center">
                                <div className="col-md-6 d-flex flex-column align-items-center">
                                    {electives.map((subject) => {
                                        const key = subject.id ?? subject.name;
                                        const isSelected = selectedElectives.includes(key);
                                        const isHovered = hoveredElective === key;
                                        const isDisabled = hasSubmitted || submitting;

                                        return (
                                            <React.Fragment key={key}>
                                                <ElectiveCard
                                                    subject={subject}
                                                    isSelected={isSelected}
                                                    isHovered={isHovered}
                                                    onClick={() => !isDisabled && this.handleSelect(key)}
                                                    onMouseEnter={() => this.handleMouseEnter(key)}
                                                    onMouseLeave={this.handleMouseLeave}
                                                    disabled={isDisabled}
                                                />
                                                {subject.is_practice_only === "1" && isSelected && (
                                                    <>
                                                      <h3 className="row mb-3 elective-card-title justify-content-center"
                                                       style={{ fontSize: "1.3rem" }}>
                                                           Choose your weekly appointment tier to complete enrollment.
                                                    </h3>
                                                    <div className="mb-3 w-100 d-flex justify-content-between gap-2">
                                                        {[1, 2, 3].map((duration) => (
                                                            <PracticeDurationCard
                                                                key={duration}
                                                                value={duration}
                                                                width={30}
                                                                isSelected={selectedDuration === duration}
                                                                onClick={() => this.handleSelectDuration(duration)}
                                                            />
                                                        ))}
                                                    </div>
                                                    </>
                                                )}
                                            </React.Fragment>
                                        );
                                    })}
                                </div>
                            </div>
                            <div className="d-flex justify-content-center">
                                <div style={{ width: "100%", maxWidth: "500px" }}>
                                    <ValidationMessage message={validationError} />
                                    <button
                                        className="mt-3 shadow"
                                        style={{
                                            backgroundColor: "#BB23F9",
                                            color: "#fff",
                                            fontWeight: "bold",
                                            fontSize: "1.1rem",
                                            padding: "16px 40px",
                                            borderRadius: "15px",
                                            border: "none",
                                            cursor: "pointer",
                                            transition: "background 0.3s ease",
                                            width: "100%",
                                        }}
                                        onClick={this.handleSubmit}
                                        disabled={hasSubmitted || submitting}
                                    >
                                        {submitting
                                            ? "Submitting..."
                                            : hasSubmitted
                                                ? "Already Enrolled"
                                                : "Submit Selection"}
                                    </button>
                                </div>
                            </div>
                        </>
                    )}
                </div>
                <Modal
                    show={showConfirmationModal}
                    onClose={() => this.setState({ showConfirmationModal: false })}
                    onConfirm={this.confirmEnrollment}
                    title="Confirm Enrollment"
                >
                    <p>
                        Are you sure you want to enroll in <strong>{selectedSubject?.name}</strong>?
                    </p>
                    <p className="text-danger mt-2" style={{ fontWeight: "bold" }}>
                        Note: Once enrolled, you will not be able to change your selected choice for the upcoming semester.
                    </p>
                </Modal>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    let level;
    if (state.myState.user && state.myState.user.user)
        level = state.myState.user.user.level;
    return {
        access_token: state.myState.user.access_token,
        currentUserLevel: level,
        user_days: state.myState.user_days,
    };
};

export default connect(mapStateToProps, { serverError })(withRouter(Enrollment));